/* Pino Mágico — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.pm-reveal:not(.pm-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pm-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var items = document.querySelectorAll('[data-pm-parallax]');
    if (!items.length || reduce) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-pm-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (-r.top * f / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCountUp() {
    var nums = document.querySelectorAll('[data-pm-count]');
    if (!nums.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-pm-count')) || 0;
      var dec = (String(target).split('.')[1] || '').length;
      var pre = el.getAttribute('data-pm-prefix') || '';
      var suf = el.getAttribute('data-pm-suffix') || '';
      if (reduce) { el.textContent = pre + target.toFixed(dec) + suf; return; }
      var t0 = null, dur = 1600;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = target * (1 - Math.pow(1 - p, 3));
        el.textContent = pre + v.toLocaleString('es-MX', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initTimers() {
    document.querySelectorAll('[data-pm-timer]').forEach(function (box) {
      var end = new Date(box.getAttribute('data-pm-timer')).getTime();
      if (isNaN(end)) { box.style.display = 'none'; return; }
      var d = box.querySelector('[data-d]'), h = box.querySelector('[data-h]'),
          m = box.querySelector('[data-m]'), s = box.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff <= 0) { box.style.display = 'none'; return; }
        d.textContent = Math.floor(diff / 864e5);
        h.textContent = pad(Math.floor(diff / 36e5) % 24);
        m.textContent = pad(Math.floor(diff / 6e4) % 60);
        s.textContent = pad(Math.floor(diff / 1e3) % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    document.querySelectorAll('[data-pm-pdp]').forEach(function (root) {
      var dataEl = root.querySelector('[data-pm-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var precio = root.querySelector('[data-pm-precio]');
      var tachado = root.querySelector('[data-pm-tachado]');
      var ahorro = root.querySelector('[data-pm-ahorro]');
      var btn = root.querySelector('[data-pm-add]');
      var btnTxt = btn ? btn.querySelector('span') : null;
      var txtAdd = btn ? btn.getAttribute('data-txt-add') : '';
      var txtSold = btn ? btn.getAttribute('data-txt-sold') : '';
      var moneyFmt = root.getAttribute('data-money') || '${{amount}}';
      var sticky = document.querySelector('[data-pm-sticky]');

      function money(cents) {
        var amount = (cents / 100).toFixed(2);
        var parts = amount.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var withDec = parts.join('.');
        var noDec = parts[0];
        return moneyFmt
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/, withDec);
      }

      /* galería */
      var main = root.querySelector('[data-pm-main] img');
      root.querySelectorAll('[data-pm-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          root.querySelectorAll('[data-pm-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = t.getAttribute('data-src');
            main.removeAttribute('srcset');
            main.style.opacity = 1;
          }, 180);
        });
      });

      function showMedia(id) {
        var t = root.querySelector('[data-pm-thumb][data-media-id="' + id + '"]');
        if (t) t.click();
      }

      /* variantes */
      function currentOptions() {
        return Array.prototype.map.call(root.querySelectorAll('[data-pm-option]'), function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function update(desdeUsuario) {
        var opts = currentOptions();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        });
        root.querySelectorAll('[data-pm-option]').forEach(function (fs, i) {
          var lab = fs.querySelector('[data-pm-selected]');
          if (lab) lab.textContent = opts[i] || '';
        });
        if (!v) {
          if (btn) { btn.disabled = true; btnTxt.textContent = txtSold; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = money(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            tachado.textContent = money(v.compare_at_price);
            tachado.hidden = false;
            if (ahorro) {
              ahorro.hidden = false;
              ahorro.textContent = ahorro.getAttribute('data-tpl').replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100));
            }
          } else {
            tachado.hidden = true;
            if (ahorro) ahorro.hidden = true;
          }
        }
        if (btn) { btn.disabled = !v.available; btnTxt.textContent = v.available ? txtAdd : txtSold; }
        if (buy) buy.disabled = !v.available;
        if (sticky) {
          var sp = sticky.querySelector('[data-pm-sticky-precio]');
          if (sp) sp.textContent = money(v.price);
          var sb = sticky.querySelector('button');
          if (sb) sb.disabled = !v.available;
        }
        if (desdeUsuario && v.featured_media) showMedia(v.featured_media.id);
        if (window.history && window.history.replaceState && root.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      root.querySelectorAll('[data-pm-option] input').forEach(function (inp) { inp.addEventListener("change", function () { update(true); }); });

      /* comprar ahora: añade y va directo al pago */
      var buy = root.querySelector("[data-pm-buy]");
      if (buy && form) {
        buy.addEventListener("click", function () {
          buy.disabled = true;
          buy.classList.add("is-loading");
          var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js";
          fetch(url, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res && res.status) { alert(res.description || res.message || "No se pudo añadir el producto."); buy.disabled = false; buy.classList.remove("is-loading"); return; }
              window.location.href = "/checkout";
            })
            .catch(function () {
              var i = document.createElement("input");
              i.type = "hidden"; i.name = "return_to"; i.value = "/checkout";
              form.appendChild(i);
              HTMLFormElement.prototype.submit.call(form);
            });
        });
      }

      /* cantidad */
      var qty = root.querySelector('[data-pm-qty]');
      root.querySelectorAll('[data-pm-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          n += parseInt(b.getAttribute('data-pm-qty-btn'), 10);
          qty.value = Math.max(1, n);
        });
      });

      /* añadir al carrito (abre el cajón del carrito si existe) */
      if (form) {
        form.addEventListener('submit', function (ev) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
          ev.preventDefault();
          if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
          var fd = new FormData(form);
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          fetch(window.routes ? window.routes.cart_add_url : '/cart/add', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { form.submit(); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          }).catch(function () { form.submit(); }).finally(function () {
            if (btn) { btn.classList.remove('is-loading'); update(); }
          });
        });
      }

      /* barra fija de compra */
      if (sticky && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        io.observe(btn);
        var sbtn = sticky.querySelector('button');
        if (sbtn) sbtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }

      if (variants.length) update();
    });
  }

  function initTabs() {
    document.querySelectorAll("[data-pm-tabs]").forEach(function (root) {
      var tabs = root.querySelectorAll("[data-pm-tab]");
      tabs.forEach(function (t) {
        t.addEventListener("click", function () {
          var id = t.getAttribute("data-pm-tab");
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle("is-active", on); x.setAttribute("aria-selected", on ? "true" : "false"); });
          root.querySelectorAll("[data-pm-panel]").forEach(function (p) {
            var on = p.getAttribute("data-pm-panel") === id;
            p.hidden = !on; p.classList.toggle("is-active", on);
            if (on) p.querySelectorAll(".pm-reveal").forEach(function (el) { el.classList.add("pm-visible"); });
          });
        });
      });
    });
  }

  function init() {
    initTabs();
    initReveal();
    initParallax();
    initCountUp();
    initTimers();
    initProducto();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
